import LoaderImage from '../../assets/images/loader-image.png'
import "../Common/DataGridLoader.scss";

export default function DataGridLoader() {
    return (
        <div className='d-flex align-items-center justify-content-center data-grid-loader-wrapper'>
            <div className='position-relative'>
                <span className='loader-border'>
                </span>
                <span className='loader-image'>
                    <img src={LoaderImage} alt='Loader Image' />
                </span>
            </div>
        </div>
    );
}